import type { NextPage } from "next";
import Link from "next/link";
import useEntries from "../src/behavior/useEntries";
import Entry from "../src/components/Entry";
import Layout from "../src/components/Layout";
import ReadMore from "../src/components/ReadMore";

import css from "./index.module.scss";

const Home: NextPage = () => {
  const { entries } = useEntries();

  return (
    <Layout className={css.container}>
      <h2>Hermeneutics</h2>
      <p className="my-4">
        Throughout Lent, this resource will be inviting you to exercise the
        muscles of hermeneutics when you read your Bible.
      </p>
      <ReadMore className="my-4">
        <div>
          <p className="my-4">
            Hermeneutics is the science and art of biblical interpretation. It’s
            science because it can be studied and tested. It’s art because it is
            dealing with language and culture which are fluid and changing so it
            takes a human artistic element use the science well.
          </p>

          <p className="my-4">
            Throughout Lent, this resource will be inviting you to exercise the
            muscles of hermeneutics when you read your Bible. Maybe you’ve had
            the experience of reading your Bible and thinking to yourself, “So
            what? What do I do with what I just read?” This resource will give
            you some steps for what to do next after you read a story or other
            passage so that reading from the Bible is less mystery and more
            learning God’s story and experiencing him through it.{" "}
          </p>

          <p className="my-4">
            At the beginning of each week, you’ll be reminded of the themes and
            structure of Luke that we’ve been thinking about since we first
            began reading the book in November. Keeping these big picture things
            in mind will help you answer questions like, “Why is the author
            including these details?” and “What do these stories have in common
            with one another?”
          </p>

          <p className="my-4">
            After that reminder, this guide will give you some steps for
            applying the science and art of biblical interpretation to what
            you’re reading. The goal is simply to practice good interpretive
            habits while you read so that the message that the author crafted
            into the book of Luke can come through to you and enrich your study
            of God’s word.
          </p>
        </div>
      </ReadMore>
      <fieldset className="my-4">
        {entries.map((e, i) => {
          return (
            <Link passHref href={`/entry/${e.id}/`} key={e.id}>
              <Entry entry={e} />
            </Link>
          );
        })}
      </fieldset>
    </Layout>
  );
};

export default Home;
